import { cn } from 'utils/cn';

interface SectionNavProps {
    sections: readonly string[];
    activeSection: string;
    onSelect: (section: string) => void;
    showIndicators?: boolean;
    ariaLabel: string;
    className?: string;
}

export const SectionNav = ({
    sections,
    activeSection,
    onSelect,
    showIndicators = false,
    ariaLabel,
    className,
}: SectionNavProps) => (
    <nav aria-label={ariaLabel} className={cn('shrink-0 lg:sticky lg:top-0 lg:w-44 lg:self-start', className)}>
        <div className="flex flex-wrap gap-1 lg:flex-col">
            {sections.map((name) => (
                <button
                    key={name}
                    type="button"
                    aria-current={activeSection === name ? 'location' : undefined}
                    onClick={() => onSelect(name)}
                    className={cn(
                        'text-cocoa-900 hover:bg-cocoa-0 focus-visible:ring-cocoa-500 cursor-pointer rounded-lg px-3 py-3 text-left text-sm font-medium focus-visible:ring-2 focus-visible:outline-none',
                        activeSection === name && 'bg-cocoa-0 font-semibold',
                        showIndicators && 'text-cocoa-600 flex items-center gap-3.5 py-2.5 text-[15px]',
                        showIndicators && activeSection === name && 'text-cocoa-900',
                    )}
                >
                    {showIndicators && (
                        <span
                            aria-hidden="true"
                            className={cn(
                                'border-cocoa-300 h-[7px] w-[7px] shrink-0 rounded-full border-[1.5px]',
                                activeSection === name && 'border-cocoa-900 bg-cocoa-900',
                            )}
                        />
                    )}
                    {name}
                </button>
            ))}
        </div>
    </nav>
);
